/**
 * Utility function that does nothing.
 * @param args Any number of arguments
 */
export function noop(...args: unknown[]) {
  void args;
}
